// usePreloadUserEngagements.js
import { useEffect } from 'react';

// Context
import { useUser } from 'context/UserContext';

import { subscribeToEngagements } from 'services/engagements/EngagementReadService';

/**
 * Custom hook to load engagements for a specific user.
 */
const usePreloadUserEngagements = () => {

  // User Context
  const { isEmailVerified, user, setUserEngagements } = useUser();

  useEffect(() => {

    // Exit early if no selected user
    if (!user || !user.key || !isEmailVerified) {
      setUserEngagements([]);
      return;
    }

    const load = () => {
      /**
       * handleUpdate
       *
       * Handles update.
       *
       * @param {unknown} engagements - engagements.
       */
      const handleUpdate = (engagements) => {
        setUserEngagements(engagements);
      };

      const params = [
        { field: "userKey", operator: "==", value: user.key }
      ];

      const sortFields = [
        { field: "dateCreated", order: "desc" }
      ];

      const unsubscribe = subscribeToEngagements({ params, sortFields }, handleUpdate);

      return unsubscribe;
    };

    const unsubscribeEngagements = load();

    return () => {
      if (unsubscribeEngagements) {
        unsubscribeEngagements();
      }
    };
  }, [isEmailVerified, user, setUserEngagements]);

};

export default usePreloadUserEngagements;
